<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="team" class="team">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row gy-4">
      {#each blocklist(block, 'members') as item}
      <div class="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
        <div class="member">
          <div class="member-img">
            <img src="{image(item, 'picture', [500, 500])}" class="img-fluid" alt="">
            <!-- <div class="social"> -->
              <!--   <a href=""><i class="bi bi-twitter"></i></a> -->
              <!--   <a href=""><i class="bi bi-facebook"></i></a> -->
              <!--   <a href=""><i class="bi bi-instagram"></i></a> -->
              <!--   <a href=""><i class="bi bi-linkedin"></i></a> -->
              <!-- </div> -->
          </div>
          <div class="member-info">
            <h4>{text(item, 'fullName')}</h4>
            <span>{text(item, 'title')}</span>
            <p>{@html richtext(item, 'description')}</p>
          </div>
        </div>
      </div>
      {/each}

    </div>

  </div>

</section>
